import React, { useState, useEffect, useCallback } from "react";
import { useCurrentPlayingContext } from "./CurrentStationContextWrapper";
import { useSrcErrorContext } from "./SourceContextWrapper";

const StreamingMetadataComponent = () => {
  const [streamTitle, setStreamTitle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { currentStation } = useCurrentPlayingContext();
  const { srcError } = useSrcErrorContext();

  const fetchWithTimeout = async (resource, options = {}) => {
    const controller = new AbortController();
    const timeout = options.timeout || 5000;
    const id = setTimeout(() => controller.abort(), timeout);

    try {
      const response = await fetch(resource, {
        ...options,
        signal: controller.signal,
      });
      clearTimeout(id);
      return response;
    } catch (error) {
      clearTimeout(id);
      if (error.name === "AbortError") {
        return { ok: false, status: 408 };
      }
      return { ok: false, status: 500 };
    }
  };

  const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  };

  useEffect(() => {
    let isMounted = true;
    let lastFetchTime = 0;
    const FETCH_INTERVAL = 10000; // Increase to 10 seconds
    const MINIMUM_FETCH_GAP = 5000; // Minimum 5 seconds between fetches

    const fetchStreamMetadata = async () => {
      const now = Date.now();
      if (now - lastFetchTime < MINIMUM_FETCH_GAP) return;
      if (!currentStation?.stream || !isMounted) return;

      lastFetchTime = now;
      setLoading(true);
      try {
        const response = await fetchWithTimeout(
          "/api/icy2?url=" + encodeURIComponent(currentStation.stream),
          {
            method: "GET",
            headers: { Accept: "application/json" },
            timeout: 3000,
          }
        );

        if (!isMounted) return;

        if (!response.ok) {
          setError("Stream Information not available");
          setStreamTitle(null);
          return;
        }

        const data = await response.json().catch(() => null);
        if (data?.metadata?.StreamTitle) {
          setError(null);
          setStreamTitle(data.metadata.StreamTitle);
        } else {
          setError("No Stream Data Available");
          setStreamTitle(null);
        }
      } catch {
        if (isMounted) {
          setError("Stream Information not available");
          setStreamTitle(null);
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    const debouncedFetch = debounce(fetchStreamMetadata, 1000);

    // Only start interval if we're playing
    let interval;
    if (srcError === "play" && currentStation?.stream) {
      debouncedFetch(); // Initial fetch
      interval = setInterval(debouncedFetch, FETCH_INTERVAL);
    }

    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, [currentStation?.stream, srcError]);

  return (
    <div className="scrolling-container">
      {" "}
      <small
        className="scrolling-text"
        style={
          {
            //   width: "100%",
            //   display: "flex",
            //   flexWrap: "wrap",
            //   padding: "10px 0px 0px 10px",
            //   color: "antiquewhite",
            //   textAlign: "initial",
          }
        }
      >
        {loading && !streamTitle ? (
          <span>Loading stream metadata...</span>
        ) : error ? (
          <span>{error}</span>
        ) : (
          // <span>ᴺᴼᵂ ᴾᴸᴬᵞᴵᴺᴳ♫♬♪ {streamTitle} ᴺᴼᵂ ᴾᴸᴬᵞᴵᴺᴳ♫♬♪</span>
          <span> {streamTitle} </span>
        )}
      </small>
    </div>
  );
};

export default StreamingMetadataComponent;
